import { createQueryKeys } from '@lukemorales/query-key-factory'

export const leads = createQueryKeys('leads', {
  all: null,
  lead: (leadId: number) => [leadId],
})

export type LeadsQueries = typeof leads
